module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAPFBMVEUAAABjdO1kdOxkde5jde1jde1kdO1kde1ldOxlePFmd+5tgO1lde1jdOz////w8v3g4/vP1fmYo/J3he6n5XwjAAAADXRSTlMA+/aR7N3Xt1E1Dw5iSxz3sQAAAM9JREFUSMetltsSgyAMRAORi2K4/v+/dtraUacPZKc9zx4ZBHdDByly8Is18oWxiw8cE13Z2MoEy9v5/OpEgVvpYDeiwuzH+40oMa81Nidq3HMfLABMlCwi2ERRICIxJjAFTAjkMcHTggkLWUywZDDBkID8Seit5NK6Vhg1v6lDJYySP5ShEWo+qQqh5yt9LrSb0OZCuQllLuQ78ArwHuCvhJ4DftL4Xfr9toLAvygcAnDMwEEGRyUcxnDcw4WCVhZcimjtwsWOjw74cAKPPw/dCm4eRGRBIgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduceIcon1.png
// module id = adbY
// module chunks = 1